import { UserSystemRoleModelPermissionMap } from '../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { PerformerTypeAdminTable } from '../../performer/type/PerformerTypeAdminTable';
import { ISettingsItem } from '../ISettingsItem';

export const PerformerSettingsItem: ISettingsItem = {
  id: 'performer',
  settingsItem: {
    key: 'performer',
    title: 'settings.requirementsExecutorTitle',
    buttons: [
      {
        title: 'settings.executors',
        url: `/settings/performer/type`,
        permissions: [UserSystemRoleModelPermissionMap['settings-performers-read']],
      },
    ],
    permissions: [UserSystemRoleModelPermissionMap['settings-performers-read']],
    infoText:
      'settings.requirementsExecutorDes',
    orderIndex: 600,
  },
  routers: [
    {
      key: 'performer-type-settings',
      path: '/settings/performer/type',
      pageTitle: 'phrases.performerType',
      component: PerformerTypeAdminTable,
      allowedPermissions: [UserSystemRoleModelPermissionMap['settings-performers-read']],
    },
  ],
};
